import { Minus, Plus } from "lucide-react";
import { useId } from "react";
import { useMessages } from "../../i18n";

interface StepperProps {
  label: string;
  value: number;
  min: number;
  max: number;
  unit: string;
  onChange: (value: number) => void;
}

export function Stepper({
  label,
  value,
  min,
  max,
  unit,
  onChange,
}: StepperProps) {
  const valueId = useId();
  const t = useMessages();

  return (
    <div className="stepper">
      <span className="stepper__label" id={`${valueId}-label`}>
        {label}
      </span>
      <div className="stepper__control">
        <button
          type="button"
          className="stepper__btn"
          onClick={() => onChange(value - 1)}
          disabled={value <= min}
          aria-label={t.app.decrease(unit)}
        >
          <Minus size={16} aria-hidden="true" />
        </button>
        <output
          className="stepper__value"
          id={valueId}
          aria-labelledby={`${valueId}-label`}
        >
          {value}
        </output>
        <button
          type="button"
          className="stepper__btn"
          onClick={() => onChange(value + 1)}
          disabled={value >= max}
          aria-label={t.app.increase(unit)}
        >
          <Plus size={16} aria-hidden="true" />
        </button>
      </div>
    </div>
  );
}
